import Loader from 'semantic-ui-react/dist/commonjs/elements/Loader';
import '@purple/semantic-ui-family-connection-theme/components/loader.css';

export default Loader;
